import { createSlice } from '@reduxjs/toolkit'

import { disconnectIntegration } from 'common/actions/integrations/common/actions/integrationActions'
import { INTEGRATION_RESET } from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'
import { fetchLists } from 'common/actions/integrations/MailChimp/actions/mailchimpActions'
import {
  setCurrentList,
  setIdentityField,
} from 'common/actions/integrations/MailChimp/actions/mailchimpModalActions'
import { CurrentList, IdentityField } from 'common/actions/integrations/MailChimp/interfaces'
import { MailChimpIntegration } from 'shared/api/common/schemas/mailChimpIntegration'

interface MailChimpState {
  lists: MailChimpIntegration[] | null
  isFetchingLists: boolean
  isDisconnecting: boolean
  currentList: CurrentList | string
  identityField: IdentityField
}

const initialState: MailChimpState = {
  identityField: {
    value: null,
    option: null,
  },
  currentList: '',
  lists: null,
  isFetchingLists: false,
  isDisconnecting: false,
}

export const mailChimpSlice = createSlice({
  name: 'mailChimp',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLists.pending, (state) => {
      state.isFetchingLists = true
    })

    builder.addCase(fetchLists.fulfilled, (state, action) => {
      const { payload } = action
      state.lists = payload.lists
      state.isFetchingLists = false
    })

    builder.addCase(fetchLists.rejected, (state) => {
      state.isFetchingLists = false
    })

    builder.addCase(setCurrentList, (state, action) => {
      const { payload } = action
      state.currentList = payload
    })

    builder.addCase(setIdentityField, (state, action) => {
      const { payload } = action
      state.identityField = payload
    })

    builder.addCase(INTEGRATION_RESET, (state) => {
      return {
        ...state,
        ...initialState,
      }
    })

    builder.addCase(disconnectIntegration.pending, (state) => {
      state.isDisconnecting = true
    })

    builder.addCase(disconnectIntegration.fulfilled, (state) => {
      state.isDisconnecting = false
    })
  },
})

export const { reducer } = mailChimpSlice
